import { memo } from "react";
import { Link } from "react-router-dom";
import { DgaIcon } from "platformscode-new-react";

/**
 * Single top-level nav item.
 * — If hasSubmenu → renders a <button> that toggles the dropdown.
 * — Otherwise → renders a React Router <Link> for direct navigation.
 */
const MenuItem = memo(({ item, isActive, isSubmenuOpen, onToggleSubmenu, onLinkClick }) => {
  const menuItemClass = `header-menu__item${isActive ? " header-menu__item--active" : ""}`;

  if (item.hasSubmenu) {
    return (
      <li>
        <button
          type="button"
          onClick={onToggleSubmenu}
          className={menuItemClass}
          aria-haspopup="true"
          aria-expanded={isSubmenuOpen}
          aria-label={`${item.label}، قائمة فرعية`}
        >
          <span className="header-menu__item-label">{item.label}</span>
          <span className="header-menu__item-arrow">
            <DgaIcon
              icon="arrow-down-01"
              variant="stroke"
              type="rounded"
              size={16}
              aria-hidden="true"
              style={{
                transition: "transform 0.3s",
                transform: isSubmenuOpen ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </span>
        </button>
      </li>
    );
  }

  return (
    <li>
      <Link to={item.href || "/"} onClick={onLinkClick} className={menuItemClass}>
        <span className="header-menu__item-label">{item.label}</span>
      </Link>
    </li>
  );
});

MenuItem.displayName = "MenuItem";
export default MenuItem;
